import React, { Component } from 'react';
import OpeningHours from '../OpeningHours';
import i18n from 'utils/translate';
import Address from '../Address';
import AdditionalInRegion from '../AdditionalInRegion';

const defaultProps = {
  office: null,
  onCommunityClick: () => {},
  onRegionClick: () => {}
};

class RegistrationOffice extends Component {
  render() {
    const { office } = this.props;
    return (
      <article className="reg-office">
        <div className="col-md-12 reg-office__card">
          <div className="row reg-office__info-top">
            <div className="col-md-4">
              <img className="img-responsive" src={office.image} alt={office.name} />
            </div>
            <div className="col-md-8">
              <div>{i18n('reg-office')}</div>
              <a className="reg-office__center-title" href={office.detailUrl}>
                {office.name}
              </a>
              <b className="head">{i18n('registers')}</b>
              <div className="reg-office__center-registers">{office.registers.longNames}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Address contacts={office.contacts} address={office.address} lat={office.lat} lon={office.lon}></Address>
            </div>
            <div className="col-md-6 hidden-xs">
              <OpeningHours openingHours={office.openingHours}></OpeningHours>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 hidden-xs">
              <AdditionalInRegion
                region={office.address}
                onCommunityClick={this.props.onCommunityClick}
                onRegionClick={this.props.onRegionClick}
                headline={i18n('other-registration-offices')}
              ></AdditionalInRegion>
            </div>
          </div>
          <div className="reg-office__info-mobile visible-xs">
            <div className="collapse" id={`more-info-${office.id}`}>
              <OpeningHours openingHours={office.openingHours}></OpeningHours>
              <AdditionalInRegion
                region={office.address}
                onCommunityClick={this.props.onCommunityClick}
                onRegionClick={this.props.onRegionClick}
                headline={i18n('other-registration-offices')}
              ></AdditionalInRegion>
            </div>
            <a
              className="show-more collapsed"
              role="button"
              data-toggle="collapse"
              href={`#more-info-${office.id}`}
              aria-expanded="false"
              aria-controls="more-info"
            >
              <span className="more">
                {' '}
                {i18n('more')} <i className="icon-nav-arrow"></i>
              </span>
              <span className="less">
                {' '}
                {i18n('less')} <i className="icon-nav-arrow"></i>
              </span>
            </a>
          </div>
        </div>
      </article>
    );
  }
}

RegistrationOffice.defaultProps = defaultProps;

export default RegistrationOffice;
